import GlobalConstants from "@constants";
import React from "react";

export const CompleteOrError = (statuses, setLoading, setError) => {
  if (
    statuses.every((status) => status === GlobalConstants.fetchStatus.complete)
  ) {
    setLoading(false);
    setError(false);
  }
  if (statuses.some((status) => status === GlobalConstants.fetchStatus.error)) {
    setLoading(false);
    setError(true);
  }
};

export const CheckOrderStatus = (status, configItem = false) => {
  let orderStatus;
  if (!status) {
    return null;
  }
  if (
    configItem &&
    (status === "Start Config" ||
      status === "StartConfig" ||
      status === "In Config" ||
      status === "InConfig" ||
      status === "Out Config" ||
      status === "OutConfig" ||
      status === "Start Shipping" ||
      status === "StartShipping")
  ) {
    return "In Config";
  }

  if (status.toLowerCase().startsWith("on hold")) {
    orderStatus = "On Hold";
  } else if (status === "Created" || status.toLowerCase() === "new") {
    orderStatus = "Ordered";
  } else if (
    status === "Start Pick" ||
    status === "StartPick" ||
    status === "PickedStaged" ||
    status === "Picked Staged" ||
    status === "Picked" ||
    status === "Start Shipping" ||
    status === "StartShipping"
  ) {
    orderStatus = "Picked";
  } else if (
    status === "Start Config" ||
    status === "StartConfig" ||
    status === "In Config" ||
    status === "InConfig"
  ) {
    orderStatus = "In Config";
  } else if (
    status === "Out Config" ||
    status === "OutConfig" ||
    status === "Shipped" ||
    status.toLowerCase() === "shipped!" ||
    status.toLowerCase() === "archived"
  ) {
    orderStatus = "Shipped";
  } else if (status === "Voided") {
    orderStatus = "Voided";
  } else if (
    status.toLowerCase() === "crating" ||
    status.toLowerCase() === "shipping"
  ) {
    orderStatus = "Config/QC";
  } else {
    orderStatus = status;
  }

  return orderStatus;
};

export const FindCurrentStep = (
  status,
  completed,
  statuses,
  isConfig = false
) => {
  const orderStatus = CheckOrderStatus(status, isConfig);

  const activeStep = statuses.findIndex((e) => e.name === orderStatus);
  return orderStatus === "Shipped" && completed ? activeStep + 1 : activeStep;
};

function findQuantityOr1(quantity: number | undefined) {
  return quantity && quantity !== 0 ? quantity : 1;
}

export const warehouseStatuses = [
  { name: "Ordered", value: 0 },
  { name: "Picked", value: 0 },
  { name: "Shipped", value: 0 },
];

export const integrationStatuses = [
  { name: "Ordered", value: 0 },
  { name: "Picked", value: 0 },
  { name: "In Config", value: 0 },
  { name: "Shipped", value: 0 },
];

export const prepareData = (pickGrouping) => {
  let data;

  if (pickGrouping && pickGrouping.length > 0) {
    let childData: any[] = [];
    data = pickGrouping.map((pickItem) => {
      const itemIsSingle =
        pickItem.items &&
        pickItem.items.length === 1 &&
        !pickItem.items[0].serialNum;

      const itemChildren = prepareOrderChildren(
        pickItem.items,
        pickItem.itemName,
        itemIsSingle
      );

      childData = [...childData, ...itemChildren];

      return {
        hierarchy: [pickItem.itemName],
        id: pickItem.itemName,
        tag: null,
        quantity: pickItem.qty
          ? itemIsSingle
            ? findQuantityOr1(
                pickItem?.items[0]?.qty ?? pickItem?.items[0]?.qtyOrdered
              )
            : pickItem.qty
          : pickItem.quantity,
      };
    });
    data = [...data, ...childData];
  } else {
    const singleData = {
      hierarchy: [pickGrouping.itemName],
      id: pickGrouping.itemName,
      tag: null,
      quantity: pickGrouping.qty
        ? pickGrouping.qty
        : findQuantityOr1(pickGrouping.quantity),
    };
    data = [
      singleData,
      ...prepareOrderChildren(pickGrouping.items, pickGrouping.itemName),
    ];
  }

  return Object.values(
    data.reduce((acc, obj) => ({ ...acc, [obj.id]: obj }), {})
  );
};
export const assetOrderGridDefinitions = () => {
  const columnDefinitions = [
    { field: "tag", minWidth: 150, headerName: "Tag" },
    {
      field: "quantity",
      minWidth: 120,
      type: "number",
      headerName: "Quantity",
    },
  ];
  const groupingColDef = {
    headerName: "Item",
    minWidth: 180,
    flex: 0.3,
    hideable: false,
    disableReorder: true,
    renderHeader: (params) => {
      return (
        <div style={{ marginLeft: "45px" }}>{params.colDef.headerName}</div>
      );
    },
  };
  return { columnDefinitions, groupingColDef };
};
const prepareOrderChildren = (items, parentItem, isSingle) => {
  let groupedItems = [];
  let childrenData = [];

  if (items && !isSingle && items.length > 0) {
    items.forEach((item) => {
      const existingItemIndex = groupedItems.findIndex(
        (existing) =>
          existing.assetTag === item.assetTag &&
          existing.serialNum === item.serialNum
      );
      if (existingItemIndex === -1) {
        groupedItems = [
          ...groupedItems,
          {
            assetTag: item.assetTag,
            serialNum: item.serialNum,
            count: findQuantityOr1(item.quantity),
          },
        ];
      } else {
        groupedItems[existingItemIndex] = Object.assign(
          {},
          groupedItems[existingItemIndex],
          {
            ...groupedItems[existingItemIndex],
            count:
              item.quantity && item.quantity !== 0
                ? (groupedItems[existingItemIndex].count += item.quantity)
                : ++groupedItems[existingItemIndex].count,
          }
        );
      }
    });
  }
  if (groupedItems.length > 0) {
    childrenData = groupedItems.map((item, i) => {
      return {
        hierarchy: [parentItem, item.serialNum ?? "N/A"],
        id: parentItem + i,
        tag: item.assetTag,
        quantity: item.count,
      };
    });
  }

  return childrenData;
};

export const FilterByState = (state, trackingNums) => {
  // FIXME: Review this logic to resolve the eslint ignore (Arrow function with missing return)
  // eslint-disable-next-line array-callback-return
  return trackingNums.filter((trackingNum) => {
    if (trackingNum.items?.length > 0) {
      return CheckOrderStatus(trackingNum.items[0]?.orderStatus) === state;
    }
  });
};
